import { Editor, Node, Path, Range } from 'slate';
import { ReactEditor } from 'slate-react';

export const isMarkActive = (editor: ReactEditor, format: string) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
};

export const toggleMark = (editor: ReactEditor, format: string) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    return Editor.removeMark(editor, format);
  }
  return Editor.addMark(editor, format, true);
};

/**
 * Get Nodes at a given Range and check if they all pass a certain condition
 * @param editor
 * @param range
 * @param condition
 */
export const isAllNodesOfConditionInRange = (
  editor: ReactEditor,
  range: Range | undefined,
  condition: (n: Node, path: Path) => boolean,
) => {
  if (!range) {
    return false;
  }

  const nodes = Editor.nodes(editor, {
    at: range,
    mode: 'lowest',
  });

  // eslint-disable-next-line no-restricted-syntax
  for (const [node, path] of nodes) {
    if (!condition(node, path)) {
      return false;
    }
  }

  return true;
};
